import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AdminsRoutingModule} from './admins-routing.module';
import {AdminsComponent} from './admins.component';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {AddAdminComponent} from './add-admin/add-admin.component';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
// @ts-ignore
import {CoreSidebarModule} from '../../../@core/components';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [AdminsComponent, AddAdminComponent],
    imports: [
        CommonModule,
        AdminsRoutingModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CardSnippetModule,
        NgxDatatableModule,
        CoreSidebarModule,
        NgbPaginationModule
    ],
    exports: [AdminsComponent, AddAdminComponent]
})

export class AdminsModule {
}
